import { IsWalletAvailableService } from "@app/core/wallet/domain/service/is-wallet-available.service";
import { map, Observable, throwError } from "rxjs";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { inject } from "@angular/core";
import { IsWalletAvailableWS } from "@app/core/wallet/infraestructure/webservice/is-wallet-available.ws";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { IsWalletAvailableWSSerializer } from "@app/core/wallet/infraestructure/mapper/is-wallet-available-ws-serializer";

export class IsWalletAvailableDataService implements IsWalletAvailableService {
    private readonly tokenRepo = inject(TokenRepo);
    private readonly isWalletAvailableWS = inject(IsWalletAvailableWS);
    private readonly isWalletAvailableWSSerializer = inject(IsWalletAvailableWSSerializer);

    execute(): Observable<boolean> {
        const token = this.tokenRepo.get();
        if (token == null) {
            return throwError(() => new MissingCredentialsError());
        }
        return this.isWalletAvailableWS.execute(token).pipe(
            map((response) => this.isWalletAvailableWSSerializer.deserialize(response))
        );
    }
}